import React from 'react'

const FooterComponents = () => {
    return (
        <div className='footer-wrapper'>
            <a href="https://donlinemc.wpengine.com/privacy-policy#GRE" target='_blank' rel="noreferrer">Privacy Policy </a>
            <a href="https://donlinemc.wpengine.com/refund-policy/" target='_blank' rel="noreferrer">Refund Policy</a>
            <a href="https://donlinemc.wpengine.com/terms-of-use/" target='_blank' rel="noreferrer">Terms Of Use  </a>
        </div>
    )
}

export default FooterComponents